export default function AddressesPage() {
  return (
    <div className="max-w-4xl mx-auto py-8 px-4">
      <h1 className="text-2xl font-bold mb-6">Addresses</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p>Addresses content goes here...</p>
      </div>
    </div>
  );
}